import React from 'react';
import './styles.css';

export const Checkbox = ({
  className,
  defaultChecked,
  label,
  onChange,
  field,
  form,
  disabledCheckbox,
  ...props
}) => {
  return (
    <div className={`check-wrapper ${className}`}>
      <label className="check-container" htmlFor={label}>
        {field ? (
          <input {...props} {...field} type="checkbox" id={label} />
        ) : (
          <input
            {...props}
            defaultChecked={defaultChecked}
            type="checkbox"
            onChange={onChange}
            disabled={disabledCheckbox}
            id={label}
          />
        )}
        {label}
        <span className="checkmark" />
      </label>
    </div>
  );
};
